import { get, find, remove, pullAll, isEmpty } from 'lodash';
import getContent from '../lib/dictionaryFetcher';

const PP_SHOPPING_CARD = 'pp_third_party_shopping_card',
  US = 'US',
  GB = 'gb';

const SELLING = ['grailed', 'swappa', 'bonanza', 'hood', 'onbuy', 'wish'];
const SHOPPINGCARTS = ['bigcommerce'];
const PARTNERS = [...SELLING, ...SHOPPINGCARTS];

const getPartnerCategory = partner => {
  if (SELLING.includes(partner)) {
    return 'selling';
  } else if (SHOPPINGCARTS.includes(partner)) {
    return 'shoppingcarts';
  }
  return '';
};

export const getCategories = state => {
  const otss = get(state, 'app.context.user.eligibility.otss', []),
    externalTool = get(state, 'app.context.user.eligibility.tools', {}),
    isGB = get(state, 'app.context.locale.country', US).toLowerCase() === GB;

  const categories = get(state, 'metadata.categories', []),
    selling = find(categories, { name: 'selling' }),
    business = find(categories, { name: 'business' });

  if (isGB) {
    if (selling) {
      selling.items = [PP_SHOPPING_CARD];
    }
    if (business && get(business, 'items', []).length) {
      remove(business.items, item => item === PP_SHOPPING_CARD);
    }
  } else if (otss.length && get(selling, 'items', []).length) {
    pullAll(selling.items, otss);
  }

  if (!isEmpty(externalTool) && !business.items.includes(externalTool.name)) {
    business.items.push(externalTool.name);
  }

  return categories;
};

export const getTools = state => {
  const tools = get(state, 'myapps.tools', {}),
    externalTool = get(state, 'app.context.user.eligibility.tools', {});

  if (!isEmpty(externalTool)) {
    tools[externalTool.name] = {
      name: getContent('merchanthub', `apps.${externalTool.name}.title`, ''),
      description: getContent(
        'merchanthub',
        `apps.${externalTool.name}.description`,
        ''
      ),
      favorite: false,
      active: true,
      key: externalTool.name,
      link: externalTool.link,
      type: 'tool',
      external: true
    };
  }

  return tools;
};

export const getFeatured = state => {
  const otss = get(state, 'app.context.user.eligibility.otss', []);
  const featured = {};
  const partner = find(PARTNERS, partner => otss.includes(partner));

  if (otss.length && partner) {
    featured[getPartnerCategory(partner)] = partner;
  }
  return featured;
};
